import { CHCScrollSection } from "./scroll-section.component.js";
customElements.define("chc-scroll-section", CHCScrollSection);
export {
  CHCScrollSection
};
//# sourceMappingURL=scroll-section.js.map
